
import Splash from "../Pages/Splash";
import Home from "../Pages/Home/Home";
import Login from "../Pages/Auth/Login";
import VerifyOTP from "../Pages/Auth/VerifyOTP";
import Profile from "../Pages/Profile/Profile";
import Content from "../Pages/Profile/Content";
import EditProfile from "../Pages/Profile/EditProfile";
import Reports from "../Pages/Home/Reports";
import SearchProduct from "../Pages/Reports/SearchProduct";
import Sales from "../Pages/Reports/Sales";
import Vendors from "../Pages/Reports/Vendors";
import Regions from "../Pages/Reports/Regions";
import Brands from "../Pages/Reports/Brands";



const appRoutes = [
    {
        pageId : 0,
        path: "/",
        component: <Splash />,
    },
    {
        pageId : 1,
        path: "/home",
        component: <Home />,
    },
    {
        pageId : 2,
        path: "/login",
        component: <Login />,
    },
    {
        pageId : 3,
        path: "/verify",
        component: <VerifyOTP />,
    },
    {
        pageId : 4,
        path: "/profile",
        component: <Profile />,
    },
    {
        pageId : 5,
        path: "/contents/:slug",
        component: <Content />,
    },
    {
        pageId : 6,
        path: "/edit-profile",
        component: <EditProfile />,
    },
    {
        pageId : 7,
        path: "/reports",
        component: <Reports />,
    },
    {
        pageId : 8,
        path: "/search-product",
        component: <SearchProduct />,
    },
    {
        pageId : 9,
        path: "/sales-report",
        component: <Sales />,
    },
    {
        pageId : 10,
        path: "/vendors-report",
        component: <Vendors />,
    },
    {
        pageId : 11,
        path: "/regions-report",
        component: <Regions />,
    },
    {
        pageId : 12,
        path: "/brands-report",
        component: <Brands />,
    },

];
export default appRoutes;
